import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import VueGtm from 'vue-gtm'
import VueGtag from 'vue-gtag'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/survey-page',
    name: 'SurveyPage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/SurveyPage.vue')
  },
  {
    path: '/appreciate',
    name: 'Appreciate',
    component: () => import('../views/Appreciate.vue')
  }
]

const router = new VueRouter({
  routes
})
Vue.use(VueGtag, {
  config: { id: 'UA-849994-6' }
}, router)

Vue.use(VueGtm, {
  id: 'GTM-N7VGWC7'
})

export default router
